import { Component, Vue } from 'vue-property-decorator';
import { Toaster, Toggle } from '@/Components';
import { ToasterService } from '@/Services/ToasterService';
import PanelService from '@/Application/Services/PanelService';
import MasterDataService from '@/Services/MasterDataService';
import { securityService } from '@/Application/Services/auth/SecurityService';
import UserService from '@/Services/UserService';
import ClientService from '@/Services/ClientService';
import { Languages, Constants, PaymentsPlanStatusTypes, Roles } from '@/Domain/enum';
import { Candidate, ClientInfo, PaymentPlan, Security } from '@/Domain/Entities';
import * as sdPanel from '../../node_modules/saviafront/lib/js/compiled/sd-panel';
import * as notification from '../../node_modules/saviafront/lib/js/compiled/notification';
import i18n from '../lang';
import axios from 'axios';
import moment from 'moment';
import _ from 'lodash';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import componentsGlobal from '@/Components/componentsGlobal';
import CandidatesSearch from '@/Components/CandidatesSearch/CandidatesSearch';
import INotificable from '@/Domain/interfaces/INotificable';
import CookiesService from '@/Services/CookiesService';

Object.entries(componentsGlobal).forEach(([name, component]) => {
    Vue.component(name, component);
});

@Component({
    components: { Toaster, Toggle, CandidatesSearch },
    computed: {
        ...mapState('featureFlagsStore', ['header', 'multiLanguage']),
        ...mapState('languagesStore', { availableLanguajes: 'availables', currentLanguage: 'current' }),
        ...mapState('dateFormatStore', { dateFormat: 'dateFormat'}),
        ...mapGetters('candidateStore', { candidateInfo: 'getCandidateInfo' }),
        ...mapGetters('userStore', { authData: 'getAuthData' }),
        showHeader(): boolean {
            return this.$route.meta.header;
        },
        headerText(): string {
            return this.$route.meta.header.headerText;
        },
        headerURL(): string {
            return this.$route.meta.header.headerURL;
        },
        headerButton(): string {
            return this.$route.meta.header.headerButton;
        },
        headerImageClass(): string {
            return this.$route.meta.header.headerImageClass;
        },
        fullWidth(): string {
            return this.$route.meta.fullWidth;
        },
        dashboardRouteActive() {
            return this.$route.fullPath.indexOf(Constants.routeActive.DASHBOARD) === 0;
        },
        publicationRouteActive() {
            return this.$route.fullPath.indexOf(Constants.routeActive.PROCESS) === 0 || this.$route.fullPath.indexOf(Constants.routeActive.BOEP) === 0;
        },
        listManagementRouteActive() {
            return this.$route.fullPath.indexOf(Constants.routeActive.LIST_MANAGEMENT) === 0;
        },
        scalingRouteActive() {
            return this.$route.fullPath.indexOf(Constants.routeActive.RATINGS) === 0;
        },
        replacementRouteActive() {
            return this.$route.fullPath.indexOf(Constants.routeActive.REPLACEMENT) === 0;
        },
        candidatesRouteActive() {
            return this.$route.fullPath.indexOf(Constants.routeActive.CANDIDATES) === 0;
        },
        isAdminUser() {
            return (this as Layout).profile.adminRole === Roles.ADMIN;
        },
        isUserWithRole() {
            return (this as Layout).profile.adminRole !== Roles.NOROLE && (this as Layout).profile.adminRole !== Roles.DISABLED;
        }
    },
    methods: {
        ...mapActions('languagesStore', ['setAvailableLanguage']),
        ...mapMutations('languagesStore', ['setCurrentLanguage']),
        ...mapMutations('dateFormatStore', ['setDateFormat']),
        ...mapMutations('candidateStore', ['setCandidateInfo'])
    }
})

export default class Layout extends Vue {
    dateFormat!: string;
    availableLanguajes!: string[];
    currentLanguage!: string;
    isAdminUser!: boolean;
    candidateInfo!: Candidate | null;
    authData!: { role: string, saviaHubClientId: string };

    Languages = Languages;
    PaymentsPlanStatusTypes = PaymentsPlanStatusTypes;
    
    clientInfo: any = null;
    notificationList: any[] = [];
    mgr = securityService;
    nameClient: string = '';
    security: Security = new Security({});
    currentPassword = '';
    newPassword = '';
    repeatPassword = '';
    profile: any = null;
    modalAuthentication: boolean = false;
    twoFactor: boolean = false;
    notRecommendBrowser: boolean = false;
    paymentPlanClient: PaymentPlan = new PaymentPlan({});
    isPlanExceed: boolean = false;
    isPlanWarning: boolean = false;
    planClient: any = null;
    lastLogin: any = null;
    loading: boolean = false;
    showModalPersecutory: boolean = false;
    timeoutModalPersecutory: any = null;
    serviceStopStartDate: moment.Moment = moment('2025-02-19T16:30:00');
    serviceStopEndDate: moment.Moment = moment('2025-02-19T18:30:00');
    serviceStopTranslationData = { dayMonth: this.serviceStopStartDate.format('DD/MM'), startHour: this.serviceStopStartDate.format('HH:mm'), endHour: this.serviceStopEndDate.format('HH:mm') };
    isServiceStopActive: boolean = moment().utc() <= this.serviceStopStartDate;
    showServiceStopModal: boolean = false;
    dontShowServiceStopModalAgain: boolean = false;
    showNotificationServiceStop: boolean =  this.isServiceStopActive;
    serviceStopLocalStorageKey = 'dontShowServiceStopModal';
    isCandiateSlideOverVissible: boolean = false;
    saviaHubAuthUrl = process.env.VUE_APP_BASE_URL_SAVIA_HUB + 'protocol/openid-connect/auth';
    currentWeekRange = { start: moment().subtract(7, 'days').startOf('day'), end: moment()};
    newsFunctionalities: INotificable[] = [];
    newsFunctionalitiesReaded: INotificable[] = [];
    onScreenNewFunctionality: INotificable = { id: '', title: '', description: '', version: '', publicationDate: '' };
    showNewsModal: boolean = false;
    latestNew: INotificable | null = null;
    incidence: any | null = null;
    showNotificationIncidence: boolean = false;

    setAvailableLanguage!: (arg1: any) => void;
    setCurrentLanguage!: (arg1: string) => void;
    setDateFormat!: (arg1: string) => void;
    setCandidateInfo!: (arg1: null) => void;

    get currentIndexOfActiveNew() {
        return this.newsFunctionalities.findIndex((item: INotificable) => item.id === this.onScreenNewFunctionality.id);
    }

    newFunctionalityReaded() {
        CookiesService.createCookie(`NewReaded${this.onScreenNewFunctionality.id}`, this.onScreenNewFunctionality.id, moment().add(1, 'week').toDate().toUTCString());
        const newActiveIndex = this.newsFunctionalities.findIndex((item: INotificable) => item.id === this.onScreenNewFunctionality.id);
        this.newsFunctionalitiesReaded.push(this.onScreenNewFunctionality);
        if (this.newsFunctionalities[newActiveIndex + 1] !== undefined) {
            this.onScreenNewFunctionality = this.newsFunctionalities[newActiveIndex + 1];
            return;
        }
        this.onScreenNewFunctionality = { id: '', title: '', description: '', version: '', publicationDate: '' };
        this.showNewsModal = false;
        this.removeNewFunctionalityReaded();
    }

    removeNewFunctionalityReaded() {
        this.newsFunctionalitiesReaded.forEach((newFunctionality: INotificable) => {
            this.newsFunctionalities = this.newsFunctionalities.filter((item: INotificable) => item.id !== newFunctionality.id);
        });
    }
    
    removeCandidateInfo() {
        this.setCandidateInfo(null);
    }

    changeLocal(language: string) {
        i18n.locale = language;
        moment.locale(language);
        const l = 'L';
        this.setDateFormat((moment().locale(this.$i18n.locale).localeData() as any)._longDateFormat[l].replace(/-/g, '/'));
        window.localStorage.setItem('local', language);
        axios.defaults.headers.common['Accept-Language'] = i18n.locale;
        this.setCurrentLanguage(language);
    }

    getImageUrl(image: string) {
        return require('../../assets/img/' + image);
    }
    
    goToChangePassword() {
        const redirectUrl = encodeURIComponent(window.location.href);

        window.location.href = `${this.saviaHubAuthUrl}?client_id=${this.authData.saviaHubClientId}&redirect_uri=${redirectUrl}&response_type=code&scope=openid&kc_action=UPDATE_PASSWORD`;
    }

    goToJira() {
        window.open('https://espacioclientes.berger-levrault.es/');
    }

    openModalAuthentication() {
        if (this.security.twoFactorMandatory) {
            return;
        }
        this.modalAuthentication = true;
        this.twoFactor = _.cloneDeep(this.profile.twoFactor);
    }

    closeModalAuthentication() {
        this.modalAuthentication = false;
    }

    acceptModalServiceStop() {
        if (this.dontShowServiceStopModalAgain) {
            const serviceStopData = { serviceStopNotificationReaded: this.dontShowServiceStopModalAgain, expires: this.serviceStopEndDate};
            localStorage.setItem(this.serviceStopLocalStorageKey, JSON.stringify(serviceStopData));
        }
        this.showServiceStopModal = false;
    }

    checkModalServiceStopLocalStorage() {
        const serviceStopItem = localStorage.getItem(this.serviceStopLocalStorageKey);
        if (!serviceStopItem) {
            return;
        }
        const serviceStopItemData = JSON.parse(serviceStopItem);
        if (moment() > moment(serviceStopItemData.expires)) {
            localStorage.removeItem(this.serviceStopLocalStorageKey);
        }
    }
    
    resetTimeModal() {       
        this.showModalPersecutory = false;
        this.timeoutModalPersecutory = setTimeout(this.setModalPersecutory, 600000);
    }

    updateDoubleAuthentication() {
        this.modalAuthentication = false;
        UserService.updateDoubleAuthentication(this.clientInfo.getClientId(), this.profile.sub, this.twoFactor).then(() => {
            ToasterService.showSuccess(i18n.t('lang.toaster.saveChanged') as any, i18n.t('lang.toaster.goodJob') as any);
            this.profile.twoFactor = this.twoFactor;
        }).catch(error => console.log(error));
    }

    getLastLogin() {
        this.lastLogin = moment.unix(this.profile.lastConnectionTimestamp).local();
    }

    setModalPersecutory() {
        this.showModalPersecutory = true;
        PanelService.panelsClose();
    }

    async getSubscriptionPlan() {
        this.paymentPlanClient = new PaymentPlan(await ClientService.getSubscriptionPlan());
        this.clientInfo.setPaymentPlanSelected(this.paymentPlanClient.paymentPlan);
        this.planClient = this.clientInfo.getPaymentPlanSelected();
        this.isPlanExceed = this.paymentPlanClient.levelPlanProcess === PaymentsPlanStatusTypes.enum.EXCEED || this.paymentPlanClient.levelPlanInscriptions === PaymentsPlanStatusTypes.enum.EXCEED;
        this.isPlanWarning = this.paymentPlanClient.levelPlanProcess === PaymentsPlanStatusTypes.enum.WARNING || this.paymentPlanClient.levelPlanInscriptions === PaymentsPlanStatusTypes.enum.WARNING;
        if (!this.isPlanExceed) {
            clearTimeout(this.timeoutModalPersecutory);
            this.timeoutModalPersecutory = null;
        } else if (!this.timeoutModalPersecutory) {
            this.setModalPersecutory();
        }
        this.$nextTick(() => {
            notification.initialize();
        });
        return [this.paymentPlanClient, this.isPlanExceed, this.isPlanWarning, this.planClient];
    }

    setLoadingAndPanel() {
        this.loading = false;
        this.$nextTick(() => {
            sdPanel.initialize();
        });
    }

    toggleCandatidatesSlideOver() {
        this.isCandiateSlideOverVissible = !this.isCandiateSlideOverVissible;
    }

    closeNewFunctionalityModal() {
        this.showNewsModal = false;
        this.removeNewFunctionalityReaded();
        this.onScreenNewFunctionality = { id: '', title: '', description: '', version: '', publicationDate: '' };
    }

    async init() {
        MasterDataService.getClientLanguajes().then(response => {
            i18n.locale = window.localStorage.getItem('local') !== null ? window.localStorage.getItem('local') as string : (response as any).defaultLanguage;
            axios.defaults.headers.common['Accept-Language'] = i18n.locale;
            this.setAvailableLanguage(response);
            this.setCurrentLanguage(i18n.locale);
            MasterDataService.getClientInfo()
                .then(responseMasterData => {
                    this.clientInfo = ClientInfo.getInstance(responseMasterData);
                    this.nameClient = this.clientInfo.getName();
                    this.security = this.clientInfo.getSecurity();
                    this.getLastLogin();
                    this.setLoadingAndPanel();
                })
                .catch(error => console.log(error));
            this.notificationList = ToasterService.notificationList;
            moment.locale(i18n.locale);
            const l = 'L';
            this.setDateFormat((moment().locale(this.$i18n.locale).localeData() as any)._longDateFormat[l].replace(/-/g, '/'));
        }).catch(error => console.log(error));

        await this.getFeatures();
        await this.getIncidents();
    }

    async getFeatures() {
        try {
            const response = await MasterDataService.getNewFeatures(this.currentWeekRange.start.toISOString(), this.currentWeekRange.end.toISOString());
            if (response && response.length > 0) {
                this.latestNew = response[0] ? response[0] : null;
                this.newsFunctionalities = this.getNewsUnReaded(response);
                this.onScreenNewFunctionality = this.newsFunctionalities.length > 0 ? this.newsFunctionalities[0] : { id: '', title: '', description: '', version: '', publicationDate: '' };
                this.showNewsModal = this.newsFunctionalities.length > 0;
            }
        } catch (error) {
            console.error(error);
        }
    }

    async getIncidents() {
        try {
            const response = await MasterDataService.getIncidents(this.authData.role);
            if (response && response.length > 0) {
                this.incidence = response[0];
                this.showNotificationIncidence = true;
            }
        } catch (error) {
            console.error(error);
        }
    }

    getNewsUnReaded(news: INotificable[]): INotificable[] {
        const cookies = document.cookie.split(';');
        return news.filter((item: INotificable) => {
            const cookieName = `NewReaded${item.id}`;
            const isReaded = cookies.some(cookie => cookie.trim().startsWith(cookieName));
            return !isReaded;
        });
    }

    mounted() {
        this.loading = true;
        this.profile = this.$parent.$data.profile;
        this.notRecommendBrowser = this.$parent.$data.myBrowserService.notRecommendBrowser;
        this.checkModalServiceStopLocalStorage();
        this.showServiceStopModal = this.isServiceStopActive && (!localStorage.getItem(this.serviceStopLocalStorageKey));
        this.init();
    }
}
